// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"9958ae8d","171":"9e40be15","917":"d539c5f3"}[chunkId] + ".chunk.js";
};